<script setup>
import { useI18n } from 'vue-i18n';

const { t, locale } = useI18n();

const socials = [
    { name: 'instagram', link: t('instagram') },
    { name: 'tiktok', link: t('tiktok'), localesOnly: ['cs', 'sk', 'pl', 'hu'] },
    { name: 'x-twitter', link: t('x_twitter'), localesOnly: ['cs', 'sk'] },
    { name: 'facebook', link: t('facebook') },
    { name: 'you-tube', link: t('youtube') },
    { name: 'linked-in', link: t('linked_in'), localesOnly: ['cs', 'sk'] },
    { name: 'pinterest', link: t('pinterest'), localesOnly: ['cs', 'sk', 'pl', 'de'] },
];

const filteredItems = socials.filter(item => {
  if (item.localesOnly && !item.localesOnly.includes(locale.value)) { return false; }
  return true;
});

const copyright = import.meta.env.VITE_VUE_APP_SITE_NAME;
</script>

<template>
  <div class="pb-4 row mx-0 px-0 items-center">
    <p class="m-0 align-center">
      <i class="mi-bird icon-20 text-warning" /> {{ copyright }} | 2010–{{ new Date().getFullYear() }}
    </p>
    <div class="ml-n1 md:ml-auto md:mt-0 mt-3 md:col-auto col-12">
      <a
        v-for="item in filteredItems"
        :key="item"
        :href="item.link"
        class="btn btn-primary border-0 h-auto md:p-2 p-1 flex-grow-1 sm:flex-grow-0 mr-1 md:mr-0"
        target="_blank"
        rel="noreferrer"
        :aria-label="item.name"
      >
        <i
          :class="`mi-${item.name}`"
          class="icon-28 mi-no-mx mi-lh-1 text-warning"
        />
      </a>
    </div>
  </div>
</template>

<i18n>
  {
    "cs": {
    "facebook": "https://www.facebook.com/mixit.cz",
    "instagram": "https://instagram.com/mix.it",
    "linked_in": "https://www.linkedin.com/company/mixitsro/",
    "pinterest": "https://www.pinterest.com/mixitcz/",
    "tiktok": "https://www.tiktok.com/{'@'}mixit.cz",
    "x_twitter": "https://x.com/MIXITcz",
    "youtube": "https://www.youtube.com/user/MIXITCZ"
},
    "sk": {
    "facebook": "https://www.facebook.com/mixit.sk",
    "instagram": "https://instagram.com/mix.it",
    "linked_in": "https://www.linkedin.com/company/mixitsro/",
    "pinterest": "https://in.pinterest.com/mixitsk/",
    "tiktok": "https://www.tiktok.com/{'@'}mixit.sk",
    "x_twitter": "https://x.com/MIXITcz",
    "youtube": "https://www.youtube.com/channel/UC_XHgM3HQM8qNdiPKGjefCg"
},
    "pl": {
    "facebook": "https://www.facebook.com/mixitpl",
    "instagram": "https://www.instagram.com/mixit.pl/",
    "linked_in": "",
    "pinterest": "https://cz.pinterest.com/mixitpl/",
    "tiktok": "https://www.tiktok.com/{'@'}mixitpl",
    "x_twitter": "",
    "youtube": "https://www.youtube.com/user/mixitpl"
},
    "hu": {
    "facebook": "https://www.facebook.com/mixit.Hungary",
    "instagram": "https://www.instagram.com/mixit.hu",
    "linked_in": "",
    "pinterest": "",
    "tiktok": "https://www.tiktok.com/{'@'}mixit.hu",
    "x_twitter": "",
    "youtube": "https://www.youtube.com/{'@'}mixithu"
},
    "de": {
    "facebook": "https://www.facebook.com/de.mixit",
    "instagram": "https://instagram.com/mixit.de",
    "linked_in": "",
    "pinterest": "https://www.pinterest.com/mixitde/",
    "tiktok": "https://www.tiktok.com/{'@'}mixit.de",
    "x_twitter": "",
    "youtube": "https://www.youtube.com/{'@'}MIXITDE"
},
    "at": {
    "facebook": "https://www.facebook.com/de.mixit",
    "instagram": "https://instagram.com/mixit.de",
    "linked_in": "",
    "pinterest": "https://www.pinterest.com/mixitde/",
    "tiktok": "https://www.tiktok.com/{'@'}mixit.de",
    "x_twitter": "",
    "youtube": "https://www.youtube.com/{'@'}MIXITDE"
},
    "ro": {
    "facebook": "https://www.facebook.com/mixit.ro/",
    "instagram": "https://www.instagram.com/mixit.romania/",
    "linked_in": "",
    "pinterest": "",
    "tiktok": "",
    "x_twitter": "",
    "youtube": "https://www.youtube.com/{'@'}mixitro6957"
},
    "fr": {
    "facebook": "https://www.facebook.com/profile.php?id=61578298336228",
    "instagram": "https://instagram.com/mixit.fr",
    "linked_in": "https://www.linkedin.com/company/mixitsro/",
    "pinterest": " ",
    "tiktok": " ",
    "x_twitter": "https://x.com/MIXITcz",
    "youtube": "https://www.youtube.com/{'@'}MixitFRANCE"
}
  }
</i18n>
